module.exports = __webpack_public_path__ + "media/src/img/logo-uk-39900c6c3db3f576c11864437e2b5870.png";